'use strict';
import Analytics from "../../../frontend/js/analytics.js";

function init() {
    const guidListBlocks = [...document.querySelectorAll('.guide-list-block__list')];
    if (!guidListBlocks.length) {
        return;
    }

    const guideBlocks = [...guidListBlocks.map(block => block.querySelectorAll('.guide-list-item'))];

    handleShowMoreButtons()

    guideBlocks.forEach((blocks, i) => {
        blocks.forEach(block => {
            const progressBar = block.querySelector('.guide-list-item__progress-bar');
            handleProgressBars(progressBar);
        });
    });

    function handleShowMoreButtons() {
        const buttons = document.querySelectorAll('.guide-list-item__show-more');

        if (!buttons || buttons.length === 0) {
            return;
        }

        buttons.forEach(button => {
            const parentBlock = button.closest('.guide-list-item');
            const heading = parentBlock.querySelector('.guide-list-block__list .guide-list-item__block-heading').textContent;
            const panelId = button.attributes['aria-controls'].value;
            const panel = document.querySelector(`#${panelId}`);
            const showMoreText = button.querySelector('.guide-list-item__show-more-text');

            Analytics.renderGuide(heading);

            button.addEventListener('click', function (e) {
                e.preventDefault();
                const isPanelHidden = panel.getAttribute('aria-hidden') === 'true';

                panel.setAttribute('aria-hidden', isPanelHidden ? 'false' : 'true');
                showMoreText.innerText = isPanelHidden ? 'Visa mindre' : 'Visa mer';
                button.classList.toggle('guide-list-item__toggled');
                parentBlock.classList.toggle('guide-list-item__show-more--open');

                if (isPanelHidden) {
                    Analytics.expandGuide(heading);
                }
            });
        });
    }

    function handleProgressBars(bar) {
        const thumb = bar.querySelector('.guide-list-item__progress-thumb');

        // Do it once when the page is loaded
        const barRect = bar.getBoundingClientRect();
        thumb.style.height = (Math.max(barRect.top, window.innerHeight / 2) - barRect.top) + '%';

        // Then on scroll
        document.addEventListener('scroll', () => {
            const barRect = bar.getBoundingClientRect();
            thumb.style.height = (Math.max(barRect.top, window.innerHeight / 2) - barRect.top) + '%';
        });
    }
}

document.addEventListener("DOMContentLoaded", () => init());
